const INITIAL_VALUES = {
  departmentName: '',
};

export default INITIAL_VALUES;
